import { Group } from "lucide-react";
import {
  ACCESS_TOKEN,
  ACQUIRED_SOURCE,
  ADMIN_CUSTOMER_ACCOUNTING,
  ADMIN_CUSTOMER_ADDRESS,
  ADMIN_CUSTOMER_BNK_DTLS,
  ADMIN_CUSTOMER_CONTACT_PERSON,
  ADMIN_CUSTOMER_CREATE,
  ADMIN_CUSTOMER_DELETE,
  ADMIN_CUSTOMER_EDIT,
  ADMIN_CUSTOMER_PAYMENT_TERMS,
  ADMIN_CUSTOMER_TABLE,
  ADMIN_CUSTOMER_UPDATE_ACCOUNTING,
  ADMIN_CUSTOMER_UPDATE_ADDRESS,
  ADMIN_CUSTOMER_UPDATE_BNK_DTLS,
  ADMIN_CUSTOMER_UPDATE_CONTACT_PERSON,
  ADMIN_CUSTOMER_UPDATE_PAYMENT_TERMS,
  ADMIN_CUSTOMER_VIEW,
  BLOOD_GROOP,
  DISCOUNT_GROUP,
  GENDER,
  GROUP_LIST,
  ID_PROOF,
  INSURANCE_PROVIDER,
  PAYMENT_TERMS,
  RELATION,
  UPDATE_FAMILY,
  UPDATE_INSURANCE,
  UPDATE_PATIENT,
} from "../types";

export const adminCustomerCreateAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const adminCustomerTableAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const adminCustomerViewAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerEditAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerDeleteAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const adminCustomerContactPersonAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_CONTACT_PERSON,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerBnkDetailsAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_BNK_DTLS,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerPaymentTermsAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_PAYMENT_TERMS,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerAccountingAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_ACCOUNTING,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerAddressAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_ADDRESS,
    data,
    onSuccess,
    onError,
  };
};

export const adminCustomerUpdateContactPersonAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ADMIN_CUSTOMER_UPDATE_CONTACT_PERSON,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerUpdateBnkDetailsAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ADMIN_CUSTOMER_UPDATE_BNK_DTLS,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerUpdatePaymentTermsAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ADMIN_CUSTOMER_UPDATE_PAYMENT_TERMS,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerUpdateAccountingAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ADMIN_CUSTOMER_UPDATE_ACCOUNTING,
    data,
    onSuccess,
    onError,
  };
};
export const adminCustomerUpdateAddressAction = (data, onSuccess, onError) => {
  return {
    type: ADMIN_CUSTOMER_UPDATE_ADDRESS,
    data,
    onSuccess,
    onError,
  };
};

// DROP DOWNS
export const relationAction = (onSuccess, onError) => {
  return {
    type: RELATION,
    onSuccess,
    onError,
  };
};

export const insuranceProviderAction = (onSuccess, onError) => {
  return {
    type: INSURANCE_PROVIDER,
    onSuccess,
    onError,
  };
};
export const genderAction = (onSuccess, onError) => {
  return {
    type: GENDER,
    onSuccess,
    onError,
  };
};
export const bloodGroupAction = (onSuccess, onError) => {
  return {
    type: BLOOD_GROOP,
    onSuccess,
    onError,
  };
};
export const idProofAction = (onSuccess, onError) => {
  return {
    type: ID_PROOF,
    onSuccess,
    onError,
  };
};
export const paymentTermsAction = (onSuccess, onError) => {
  return {
    type: PAYMENT_TERMS,
    onSuccess,
    onError,
  };
};
export const groupAction = (onSuccess, onError) => {
  return {
    type: GROUP_LIST,
    onSuccess,
    onError,
  };
};
export const acquiredSourceAction = (onSuccess, onError) => {
  return {
    type: ACQUIRED_SOURCE,
    onSuccess,
    onError,
  };
};

export const discountGroupAction = (onSuccess, onError) => {
  return {
    type: DISCOUNT_GROUP,
    onSuccess,
    onError,
  };
};

export const updatePatientAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_PATIENT,
    data,
    onSuccess,
    onError,
  };
};
export const updateFamilyAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_FAMILY,
    onSuccess,
    data,
    onError,
  };
};
export const updateInsuranceAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_INSURANCE,
    onSuccess,
    data,
    onError,
  };
};

export const accessTokenAction = (onSuccess, onError) => {
  return {
    type: ACCESS_TOKEN,
    onSuccess,
    onError,
  };
};
